import { Link, useLocation } from "react-router-dom"
import { Menu, Grid } from "antd"
import IntlMessage from "../util-components/IntlMessage"
import Icon from "../util-components/Icon"
import navigationConfig from "consts/navigation-config"
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "consts/theme"
import utils from 'utils'
import useHiddenUsersPages from "@timenotes/shared/src/services/hidden-pages/use-hidden-users-pages"

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};


const SideNavContent = (props) => {
	const { sideNavTheme, routeInfo, hideGroupTitle, localization, toggleMobileNav } = props;
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')

	const closeMobileNav = () => {
		if (isMobile) {
			toggleMobileNav(false)
		}
	}

  const hiddenUsersPages = useHiddenUsersPages()
  const allowedNavigation = navigationConfig.filter((navItem) => !hiddenUsersPages.includes(navItem.key))

  /*
  if (!loaded) {
    // Filter out navigation items of hidden pages if permissions did not load yet!
    allowedNavigation = allowedNavigation.filter((navigationItem) => !hiddenPagesArray.includes(navigationItem.key))
  } else {
    // If permissions loaded, filter out hidden pages which user can not see

    const PAGES_ONE_CAN_NOT_SEE = API_HIDDEN_PAGES.filter((page) => {
      const permissionName = getHiddenPagePermissionName(page)
      return !permissions[permissionName]
    })

    // Disallow page display if one can not see it
    allowedNavigation = allowedNavigation.filter((navigationItem) => !PAGES_ONE_CAN_NOT_SEE.includes(navigationItem.key))
  }
  */

  // Find current selected navigation by pathname not click status
  const location = useLocation()
  const locationPathRoot = location.pathname.split('/')[1] || ''

  const selectedNavigation = allowedNavigation.find((nav) => {
    const navigationPathRoot = nav.path.split('/')[1]

    return navigationPathRoot == locationPathRoot
  }) || allowedNavigation.find((n) => n.key == 'settings') // if navigation does not matches -> highlight settings by default

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      //defaultSelectedKeys={[routeInfo?.key]}
      //defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      selectedKeys={[selectedNavigation.key]}
      className={`timenotes-sidebar ${hideGroupTitle ? "hide-group-title" : ""}`}
    >
      {allowedNavigation.map((menu) =>
        menu.submenu.length > 0 ? (
          <Menu.ItemGroup
            key={menu.key}
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  key={subMenuFirst.key}
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      {subMenuSecond.icon ? (
                        <Icon type={subMenuSecond?.icon} />
                      ) : null}
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;

  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

export default MenuContent
